var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-wrap"},[_c('ul',{staticClass:"scroll-content",style:({ top: _vm.top, transition: _vm.transition})},_vm._l((_vm.rewardList),function(reward){return _c('li',[_vm._v(_vm._s(reward.mobile)+" 获得推荐奖励"+_vm._s(reward.amount)+"元")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce90d26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward-scroll.vue
// module id = 36aw
// module chunks = 3